import { create } from "zustand";

const useNotificationStore = create((set) => {
  let debounceTimeout = null;

  return {
    selectedWorkPermitId: null,
    setSelectedWorkPermitId: (id) => {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        set({ selectedWorkPermitId: id });
      }, 300);
    },
    clearSelectedWorkPermitId: () => {
      clearTimeout(debounceTimeout);
      set({ selectedWorkPermitId: null });
    },
  };
});

export default useNotificationStore;
